module.exports = __webpack_public_path__ + "img/noise.cf6cc13a.gif";